<template>
    <div class="breadcrumb-container"  v-show="canshow">
        <el-breadcrumb separator="/" class="breadcrumb" v-show="$store.state.breadcrumbData.length > 0">
            <!-- <i class="el-icon-s-home" style="margin-right: 10px;vertical-align: middle;"></i> -->
            <el-breadcrumb-item @click="jumpPage(item)" style="color: #fff;" v-for="item in $store.state.breadcrumbData" v-bind:key="item.title" :to="{ path: item.path,query  :  {...item.query ,timestamp: Date.now()}}">
                <span>{{item.title}}</span>
            </el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <ul class="breadcrumb">
            <li v-for="item in navitems" v-bind:key="item.title"><a :href="item.path">{{item.title}}</a></li>
        </ul> -->
    </div>
</template>
<script lang="js">
export default {
    name: "topBreadcrumb",
    props:{
    },
    data() {
        return {
            canshow:true,
            navitems:[]
        }
    },
    created(){
        this.navitems =  this.$store.state.breadcrumbData
        //console.log("navitems ================",this.navitems)
    },
    methods:{
        jumpPage(item){
            //console.log("jumpPage  =====  ",item)
        },
        handleScroll() {
            this.canshow =true;
        const scrollPosition = window.scrollY + 500
    }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    watch: {
        $route(to, from) {
            //console.log(to)
            //console.log(from)

            // this.$router.go(0)
            // if (to.query !== from.query  ) {
            //  // this.$router.go(to);

            // }
            // if(to !== from)
            //  this.$router.go(to);
        }
    },
}


</script>


<style scope lang="scss">
.breadcrumb-container {
    z-index: 5;
    background-color:#efefefc1;
    width: 100%;
    position: sticky;
    padding:5px;
    top: 90px;
//     .el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
//     font-weight: 400;
//     color: #ffffff;
//     cursor: text;
// }
}


.breadcrumb {
    display: flex;
    list-style: none;
    max-width: 1200px;
    padding:0 10px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    justify-items: flex-start;
    align-items: center;
    
}

.breadcrumb li {
    margin-right: 15px;
    font-size: 0.9rem;
}

.breadcrumb li:after {
    content: '/';
    margin-left: 15px;
    color: rgba(255, 255, 255, 0.5);
}

.breadcrumb li:last-child:after {
    content: '';
    margin-left: 0;
}

.breadcrumb a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: color 0.3s, border-bottom 0.3s;
}

.breadcrumb a:hover {
    color: #fff;
}

@media (max-width: 992px) {
 
 .breadcrumb-container {
     top:90px;
   }
 }

@media (max-width: 768px) {
 
.breadcrumb-container {
    top:90px;
  }
}

</style>